type QuerySettings = Record<string, string>;

interface UrlUtils {
  querySettings(): QuerySettings;
  protocol(): string;
}

const utils = {} as UrlUtils;

export default utils;

let qs: QuerySettings | null = null;

function getQs(a: string[]): QuerySettings {
  // @ts-expect-error string[] is never "", so this early return never runs.
  if (a === "") {
    return {};
  }
  const b: QuerySettings = {};

  for (let i = 0; i < a.length; ++i) {
    const p = a[i].split("=", 2);
    if (p.length === 1) {
      b[p[0]] = "";
    } else {
      b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
    }
  }

  return b;
}

utils.querySettings = function () {
  if (qs === null) {
    qs = getQs(window.location.search.substr(1).split("&"));
  }

  return qs;
};

utils.protocol = function () {
  return window.location.protocol;
};
